import React, { PureComponent } from 'react'
import isArray from 'lodash/fp/isArray'
import isPlainObject from 'lodash/fp/isPlainObject'
import isString from 'lodash/fp/isString'
import isEmpty from 'lodash/fp/isEmpty'
import getOr from 'lodash/fp/getOr'
import compose from 'lodash/fp/compose'

import SelectWrapper from './SelectWrapper'
import SelectIcon from './SelectIcon'
import SelectBase from './SelectBase'

const isControlled = (key, props) => props[key] !== undefined
const callIf = fn => (...args) => fn && fn(...args)
const checkFilled = value => {
  if (isArray(value) || isPlainObject(value) || isString(value)) {
    return !isEmpty(value)
  }
  return value != null
}
const isFilled = compose(checkFilled, getOr('', 'value'))

class Select extends PureComponent {
  constructor(props) {
    super(props)

    if (isControlled('value', props)) {
      this.checkDirty(this.props)
    }
  }
  fieldRef = React.createRef()

  componentDidMount() {
    if (!isControlled('value', this.props)) {
      this.checkDirty(this.fieldRef.current)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      isControlled('value', this.props) &&
      prevProps.value !== this.props.value
    ) {
      this.checkDirty(this.props)
    }
  }

  handleChange = event => {
    if (!isControlled('value', this.props)) {
      this.checkDirty(this.fieldRef.current)
    }

    callIf(this.props.onChange)(event)
  }

  checkDirty(obj) {
    if (isFilled(obj)) {
      callIf(this.props.onFilled)()
      return
    }
    callIf(this.props.onEmpty)()
  }

  render() {
    const {
      name,
      id = name,
      onFilled: ignoredOnFilled,
      onEmpty: ignoredOnEmpty,
      ...props
    } = this.props

    return (
      <SelectWrapper>
        <SelectBase
          {...props}
          name={name}
          id={id}
          onChange={this.handleChange}
        />
        <SelectIcon />
      </SelectWrapper>
    )
  }
}

export default Select
